module.exports = "/assets/data/d173f4422647f3a29a4dddf3276bc588-MK18.data.json";